export const windowRef: any = () => typeof window !== "undefined" ? window : null;